// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"Cr-z","trustedRetailerTooltipWrapper":"Dr-z"};